import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconShredder: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="shredder, permanently"><path d="M2.75 12.75H21.25M4.75 9.25V2.75H19.25V9.25M5.75 16.25V19.1944M9.91667 16.25V21.25M14.0833 16.25V19.1944M18.25 16.25V21.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconShredder;
